export default __webpack_public_path__ + "static/media/c001-ngo-2.bc01a4d0.jpg";